import { Loading } from "@/components/ui/loading";
import { TourRouteBuilder } from "@/modules/tours/routes/tour-route.builder.tsx";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/tours/$tourId/route-builder")({
	component: TourRouteBuilder,
	pendingComponent: Loading,
});
